/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Delete_Share_ButtonInputs */



/**
* | output |
* | --- |
* | "Delete Share" |
*
* @param {Team_Share_Delete_Share_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_delete_share_button = /** @type {((inputs?: Team_Share_Delete_Share_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Delete_Share_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le partage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Löschen Teilen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina Condividi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить Поделиться")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar Compartir")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除共享")
	if (locale === "ja") return /** @type {LocalizedString} */ ("削除 共有")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शेयर हटाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir Compartilhar")
	return /** @type {LocalizedString} */ ("Delete Share")
});